module.exports = __webpack_public_path__ + "static/media/EngraversGothicBT.ee6b0eb7.otf";